<template>
  <div class="document" style="height: 100%">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Pending {{ properties['SYSTEM_LABEL-NEARMATCH'] }}(s/es)
          </div>
          <div
            v-if="nearMatches.length"
            class="header-subtitle"
          >
            {{ nearMatches.length }} of {{ totalCount }} Pending {{ properties['SYSTEM_LABEL-NEARMATCH'] }}(s/es)
          </div>
        </template>
      </es-header>
    </div>
    <es-loader v-if="loading" style="margin: 3rem"/>
    <es-exception
      v-if="!hasModule('PRSID:MATCH:HISTORY:VIEW')"
      exceptionMessage="Sorry, you are not authorized to access this content."
      margin="0"
      style="padding: 3rem 1rem"
    />
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
      margin="0"
      style="padding: 3rem 1rem"
    />
    <es-exception
      v-else-if="!totalCount"
      :exceptionMessage="`0 Pending ${this.properties['SYSTEM_LABEL-NEARMATCH']} Records.`"
      margin="0"
      style="padding: 3rem 1rem"
    />
    <div class="card-container bg-fff border-bottom"
      v-else>
      <pid-pending-near-match-table
        :nearMatches="nearMatches"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import axios from 'axios';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import PidPendingNearMatchTable from '@/components/PidPendingNearMatchTable.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import qs from 'qs';

library.add(
  faAngleDoubleRight,
);

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsHeader,
    EsLoader,
    PidPendingNearMatchTable,
  },
  data() {
    return {
      loading: false,
      loadingError: false,
      messages: [],
      nearMatches: [],
      totalCount: 0,
    };
  },
  props: [
    'pendingCounts',
  ],
  async created() {
    await this.onLoad();
  },
  computed: {
    ...mapGetters('lookups', [
      'pidNearMatchesTransGroup',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidTransactionStatuses',
    ]),
    async onLoad() {
      try {
        this.loading = true;
        await this.loadPidTransactionStatuses();
        await Promise.all([
          this.pendingTransactions(),
        ]);
      } catch (error) {
        // this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
        // this.messages.push(this.apiMsg);
        this.loadingError = true;
        this.hasError = true;
        // this.showMessage();
      }
      this.loading = false;
    },
    async pendingTransactions() {
      const sort = [{
        field: 'id',
        order: 'DESC',
      }];
      const trans = this.pidNearMatchesTransGroup.list.map(s => s.id).flat();
      const urlParams = {};
      urlParams.statuses = trans;
      urlParams.open = 'true';
      urlParams.pageSize = 5;
      urlParams.sort = JSON.stringify(sort);
      const res = await axios.get('personid/transactions/details',
        ({
          params: urlParams,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          },
          paramsSerializer(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          },
        }));
      this.nearMatches = res.data.data;
      this.totalCount = res.data.totalCount;
      this.pendingCounts.pendingNearMatches = this.totalCount;
    },
    // showMessage() {
    //   const type = this.hasError ? 'danger' : 'success';
    //   this.showNotification(type, this.messages);
    // },
  },
};
</script>

<style lang="sass" scoped>
</style>
